(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
/* Measure the bar and publish its height as a custom property. The message
   wraps on narrow screens, so the offset the header and <main> need is not a
   constant. */
(function () {
  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;
  if (bar.dataset.ggMeasured === 'true') return;
  bar.dataset.ggMeasured = 'true';

  function measure() {
    document.documentElement.style.setProperty(
      '--gg-announcement-height',
      bar.offsetHeight + 'px'
    );
  }

  measure();

  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(measure).observe(bar);
  } else {
    window.addEventListener('resize', measure);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* -------------------------------------------------------------------
       Background video
       ------------------------------------------------------------------- */

    var video = hero.querySelector('[data-hero-video]');

    /* ── The clip is 3.0 MB and phones do not get it ────────────────────────
       Measured 2026-10-05 in headless Chrome at 390px with an iOS UA: the home
       page transferred 5,600 KB, of which hero-video.mp4 was 3,086 KB - 55% of
       the whole page, for a decorative background behind the headline. Mobile
       LCP sits at 5.9-7.3s against desktop's 0.8-0.9s.

       The poster image is already painted and already the LCP element, so
       skipping the video costs a phone nothing visible - it keeps the still it
       was looking at anyway during the download.

       Gate on WIDTH, not on a UA string, and read it once at boot rather than
       on resize: a phone that rotates mid-visit should not suddenly start
       pulling 3 MB. Desktop behaviour is unchanged. */
    var bigEnough = window.matchMedia('(min-width: 64em)').matches;

    if (video && !reduce.matches && bigEnough) {
      var src = video.getAttribute('data-hero-video-src');
      var onScreen = true;
      var started = false;

      var play = function () {
        if (!started || !onScreen) return;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      };

      var start = function () {
        if (started) return;
        started = true;

        if (src && !video.getAttribute('src')) {
          video.preload = 'auto';
          video.setAttribute('src', src);
          video.load();
        }

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Safari throws if the metadata is not in yet. Harmless. */
        }

        play();
      };

      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      });

      /* Hold the clip until the page has finished loading, so it never
         competes with the poster for bandwidth during LCP. */
      var afterLoad = function (callback) {
        if (document.readyState === 'complete') {
          callback();
          return;
        }
        window.addEventListener('load', callback, { once: true });
      };

      var introState = document.documentElement.getAttribute('data-intro');
      var introPending = introState === 'running';

      /* theme.js may not have booted yet, in which case the attribute is
         absent but the overlay is in the DOM. Treat that as "running". */
      if (introState === null && document.querySelector('[data-intro]')) {
        introPending = true;
      }

      if (introPending) {
        window.addEventListener('intro:done', function () {
          afterLoad(start);
        }, { once: true });

        /* Failsafe: the intro runs for about 4.5s. If its event never
           arrives, the hero must not sit on a still image forever. */
        window.setTimeout(function () {
          afterLoad(start);
        }, 8000);
      } else {
        afterLoad(start);
      }

      /* Pause off-screen — the clip keeps decoding otherwise, which sustains
         scroll jank well past the hero. */
      if (typeof IntersectionObserver === 'function') {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          if (onScreen) {
            play();
          } else {
            video.pause();
          }
        }, { threshold: 0.01 }).observe(video);
      }

      window.addEventListener('pagehide', function () {
        video.pause();
      });
    }

    /* -------------------------------------------------------------------
       Parallax — desktop only, translateY only.
       The opacity fade that used to go with it was removed on purpose:
       animating opacity over a playing video re-composites the video layer
       every frame and stutters the scroll off the hero.
       ------------------------------------------------------------------- */

    var layer = hero.querySelector('[data-hero-parallax]');

    if (layer && !reduce.matches) {
      var desktop = window.matchMedia('(min-width: 64em)');
      var queued = false;

      var apply = function () {
        queued = false;
        var progress = Math.min(window.scrollY || 0, 900) / 900;
        layer.style.transform = 'translate3d(0, ' + (progress * 160).toFixed(1) + 'px, 0)';
      };

      var onScroll = function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(apply);
      };

      var sync = function () {
        if (desktop.matches) {
          window.addEventListener('scroll', onScroll, { passive: true });
          apply();
        } else {
          window.removeEventListener('scroll', onScroll);
          layer.style.transform = '';
        }
      };

      sync();

      if (desktop.addEventListener) {
        desktop.addEventListener('change', sync);
      } else if (desktop.addListener) {
        desktop.addListener(sync);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
/* Two jobs: fill the province select from the country Shopify marked up, and
   ask before a delete actually posts. Everything still works without either. */
(function () {
  var root = document.querySelector('[data-customer-addresses]');
  if (!root) return;
  if (root.dataset.ggAddressesReady === 'true') return;
  root.dataset.ggAddressesReady = 'true';

  function provincesFor(option) {
    if (!option) return [];
    var raw = option.getAttribute('data-provinces');
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function syncProvince(country) {
    var provinceSelect = document.getElementById(country.dataset.provinceSelect);
    var wrapper = document.getElementById(country.dataset.provinceWrapper);
    if (!provinceSelect || !wrapper) return;

    var list = provincesFor(country.options[country.selectedIndex]);
    var wanted = provinceSelect.dataset.default || '';

    provinceSelect.innerHTML = '';

    if (list.length === 0) {
      wrapper.hidden = true;
      provinceSelect.disabled = true;
      return;
    }

    list.forEach(function (pair) {
      var option = document.createElement('option');
      option.value = pair[0];
      option.textContent = pair[1];
      if (pair[0] === wanted) option.selected = true;
      provinceSelect.appendChild(option);
    });

    provinceSelect.disabled = false;
    wrapper.hidden = false;
  }

  root.querySelectorAll('[data-address-country]').forEach(function (country) {
    var preferred = country.dataset.default;
    if (preferred) country.value = preferred;
    syncProvince(country);
    country.addEventListener('change', function () {
      var provinceSelect = document.getElementById(country.dataset.provinceSelect);
      /* A fresh country means the saved province no longer applies. */
      if (provinceSelect) provinceSelect.dataset.default = '';
      syncProvince(country);
    });
  });

  /* A form that came back with errors is inside a closed <details>. Open it and
     send focus to the message, otherwise the page looks like nothing happened. */
  var firstError = root.querySelector('.gg-address__errors');
  if (firstError) {
    var errored = firstError.closest('details');
    if (errored) errored.open = true;
    firstError.focus();
  }

  root.querySelectorAll('[data-address-delete]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      if (window.confirm(button.dataset.confirm)) return;
      event.preventDefault();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  /* The cart page keeps itself in sync. theme.js only re-renders the drawer and
     the header bubble on a mutation, so this listens for the same event and
     pulls a fresh copy of this section through the Section Rendering API.
     Focus is restored by key, so keyboard users are not dumped back to the top
     after pressing plus or minus. */
  (function () {
    function swap() {
      var current = document.querySelector('[data-cart-page]');
      if (!current) return;

      var sectionId = current.getAttribute('data-cart-page');
      var active = document.activeElement;
      var focusKey = null;
      if (active && active.getAttribute) focusKey = active.getAttribute('data-focus-key');

      window
        .fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), {
          headers: { Accept: 'text/html' }
        })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var incoming = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-cart-page]');
          var target = document.querySelector('[data-cart-page]');
          if (!incoming || !target) return;

          target.replaceWith(incoming);

          if (window.GG && window.GG.observeReveals) window.GG.observeReveals(document);

          if (!focusKey) return;
          var restored = document.querySelector('[data-focus-key="' + focusKey + '"]');
          if (restored && restored.focus) restored.focus({ preventScroll: true });
        })
        .catch(function () {
          /* Better a reload than a page showing a cart that no longer exists. */
          window.location.reload();
        });
    }

    window.addEventListener('cart:updated', swap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Submit the sort form as soon as the shopper picks an ordering. Delegated,
     so it survives a theme-editor section reload and costs nothing on the pages
     that have no sort control. The form still works without this — see the
     submit button in the markup. */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-collection-sort]');
    if (!select) return;
    if (!select.form) return;
    select.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-pack"]) return;
  try {
    
  /* main-pack — the variety pack chooser (draft). Scoped to [data-gg-pack] and
     data-gg-* attributes so it never meets main-product's pack script. */
  (function () {
    function toInt(value) {
      var n = parseInt(value, 10);
      return isNaN(n) || n < 0 ? 0 : n;
    }

    function fill(template, values) {
      return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
        return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
      });
    }

    function setup(root) {
      if (!root || root.getAttribute('data-gg-ready') === 'true') return;
      var form = root.querySelector('[data-gg-form]');
      if (!form) return;
      root.setAttribute('data-gg-ready', 'true');

      var qtys = Array.prototype.slice.call(form.querySelectorAll('[data-gg-qty]'));
      var sizes = Array.prototype.slice.call(form.querySelectorAll('[data-gg-size]'));
      var counts = Array.prototype.slice.call(root.querySelectorAll('[data-gg-count]'));
      var fills = Array.prototype.slice.call(root.querySelectorAll('[data-gg-fill]'));
      var prices = Array.prototype.slice.call(root.querySelectorAll('[data-gg-price]'));
      var submit = form.querySelector('[data-gg-submit]');
      var error = form.querySelector('[data-gg-error]');
      var gallery = root.querySelector('[data-gg-gallery]');
      var single = form.getAttribute('data-gg-mode') === 'single';

      function checkedSize() {
        for (var i = 0; i < sizes.length; i++) {
          if (sizes[i].checked) return sizes[i];
        }
        return null;
      }

      function packSize() {
        var input = checkedSize();
        return input ? toInt(input.getAttribute('data-gg-size')) : toInt(form.getAttribute('data-gg-pack-size'));
      }

      function chosen() {
        return qtys.reduce(function (sum, input) { return sum + toInt(input.value); }, 0);
      }

      function showFrame(index) {
        if (!gallery) return;
        var frames = gallery.querySelectorAll('[data-gg-frame]');
        var thumbs = gallery.querySelectorAll('[data-gg-thumb]');
        if (!frames.length) return;
        var target = ((index % frames.length) + frames.length) % frames.length;
        Array.prototype.forEach.call(frames, function (frame, i) {
          frame.classList.toggle('is-active', i === target);
        });
        Array.prototype.forEach.call(thumbs, function (thumb, i) {
          thumb.setAttribute('aria-pressed', i === target ? 'true' : 'false');
        });
      }

      function syncVariant(fromUser) {
        var input = checkedSize();
        sizes.forEach(function (radio) {
          var card = radio.closest('[data-gg-size-card]');
          if (card) card.classList.toggle('is-selected', radio.checked);
        });
        if (!input) return;
        prices.forEach(function (row) {
          row.hidden = row.getAttribute('data-gg-price') !== input.value;
        });
        var media = parseInt(input.getAttribute('data-gg-media'), 10);
        if (fromUser && !isNaN(media) && media >= 0) showFrame(media);
        if (fromUser && window.history && history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', input.value);
            history.replaceState(history.state, '', url.toString());
          } catch (e) {}
        }
      }

      function render() {
        if (single) {
          if (submit) {
            var picked = checkedSize();
            if (picked && !picked.disabled) {
              submit.textContent = fill(submit.getAttribute('data-label-buy'), { price: picked.getAttribute('data-gg-money') });
              submit.disabled = false;
            }
          }
          return;
        }
        var size = packSize();
        var total = chosen();
        var remaining = size - total;
        var state = total === 0 ? 'empty' : (remaining === 0 ? 'full' : (remaining < 0 ? 'over' : 'partial'));
        form.setAttribute('data-gg-state', state);

        var countText;
        if (remaining < 0) countText = fill(form.getAttribute('data-label-over'), { count: -remaining });
        else if (remaining === 0) countText = form.getAttribute('data-label-complete');
        else countText = fill(form.getAttribute('data-label-progress'), { count: total, total: size });
        counts.forEach(function (el) { el.textContent = countText; });

        var pct = size > 0 ? Math.min(100, Math.round((total / size) * 100)) : 0;
        fills.forEach(function (el) { el.style.width = pct + '%'; });

        if (submit) {
          var label;
          if (remaining === 0) {
            var input = checkedSize();
            var money = input ? input.getAttribute('data-gg-money') : '';
            label = submit.getAttribute('data-label-ready') + (money ? ' · ' + money : '');
          } else if (remaining > 0) {
            label = remaining === 1 ? form.getAttribute('data-label-one') : fill(form.getAttribute('data-label-other'), { count: remaining });
          } else {
            label = fill(form.getAttribute('data-label-over'), { count: -remaining });
          }
          submit.textContent = label;
          submit.disabled = remaining !== 0;
        }

        qtys.forEach(function (input) {
          var value = toInt(input.value);
          input.max = String(size);
          var card = input.closest('[data-gg-jar]');
          if (!card) return;
          card.setAttribute('data-chosen', value > 0 ? 'true' : 'false');
          var badge = card.querySelector('[data-gg-badge]');
          if (badge) badge.textContent = value > 0 ? '×' + value : '';
          var minus = card.querySelector('[data-gg-step="-1"]');
          if (minus) minus.disabled = value <= 0;
          Array.prototype.forEach.call(card.querySelectorAll('[data-gg-step="1"]'), function (plus) {
            plus.disabled = total >= size;
          });
        });

        if (error && state !== 'over') error.hidden = true;
      }

      form.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-gg-toggle]');
        if (toggle && form.contains(toggle)) {
          var open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          var jar = toggle.closest('[data-gg-jar]');
          if (jar) jar.classList.toggle('is-open', open);
          return;
        }
        var step = event.target.closest('[data-gg-step]');
        if (!step || !form.contains(step)) return;
        event.preventDefault();
        var card = step.closest('[data-gg-jar]');
        var input = card ? card.querySelector('[data-gg-qty]') : null;
        if (!input) return;
        var delta = parseInt(step.getAttribute('data-gg-step'), 10) || 0;
        if (delta > 0 && chosen() >= packSize()) return;
        input.value = String(Math.max(0, toInt(input.value) + delta));
        render();
        var next = null;
        if (step.classList.contains('gg-jar__add')) next = card.querySelector('.gg-jar__stepper [data-gg-step="-1"]');
        else if (toInt(input.value) === 0) next = card.querySelector('.gg-jar__add');
        if (next && !next.disabled) next.focus();
      });

      form.addEventListener('input', function (event) {
        if (event.target.matches('[data-gg-qty]')) render();
      });

      form.addEventListener('change', function (event) {
        var target = event.target;
        if (target.matches('[data-gg-size]')) {
          syncVariant(true);
          render();
        } else if (target.matches('[data-gg-qty]')) {
          target.value = String(toInt(target.value));
          render();
        }
      });

      form.addEventListener('submit', function (event) {
        if (single) return;
        var size = packSize();
        var total = chosen();
        if (total !== size) {
          event.preventDefault();
          if (error) {
            var short = size - total;
            error.textContent = short < 0
              ? fill(form.getAttribute('data-label-over'), { count: -short })
              : (short === 1 ? form.getAttribute('data-label-one') : fill(form.getAttribute('data-label-other'), { count: short }));
            error.hidden = false;
          }
          return;
        }
        qtys.forEach(function (input) {
          if (toInt(input.value) === 0) input.disabled = true;
        });
      });

      /* Back from the basket through the back/forward cache: the zero rows
         were disabled for the post, so switch them back on. */
      window.addEventListener('pageshow', function () {
        qtys.forEach(function (input) { input.disabled = false; });
        render();
      });

      var chooser = root.querySelector('.gg-chooser');
      if (chooser && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          document.documentElement.classList.toggle('gg-chooser-in-view', entries[0].isIntersecting);
        }).observe(chooser);
      }

      if (gallery) {
        gallery.addEventListener('click', function (event) {
          var thumb = event.target.closest('[data-gg-thumb]');
          if (!thumb) return;
          event.preventDefault();
          showFrame(parseInt(thumb.getAttribute('data-gg-thumb'), 10) || 0);
        });
      }

      syncVariant(false);
      render();
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gg-pack]'), setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /* Product gallery -------------------------------------------------------
     Thumbnails, previous/next, hover zoom and the full-screen viewer, all
     delegated from document so they survive a theme-editor section reload and
     cost nothing on pages with no gallery. */

  function galleryFrames(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-media-frame]'));
  }

  function activeIndex(gallery) {
    var frames = galleryFrames(gallery);
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function showFrame(gallery, index) {
    var frames = galleryFrames(gallery);
    if (!frames.length) return;

    /* Wrap rather than clamp, so next from the last photo returns to the first.
       A gallery of four is short enough that a dead-ended arrow reads as broken
       rather than as a boundary. */
    var count = frames.length;
    var target = ((index % count) + count) % count;

    frames.forEach(function (frame, i) {
      var isActive = i === target;
      frame.classList.toggle('is-active', isActive);

      /* Keep the fly-to-cart source pointing at whatever is on screen —
         theme.js measures the element, and a hidden one has no size. */
      if (isActive) {
        frame.setAttribute('data-fly-hero', '');
      } else {
        frame.removeAttribute('data-fly-hero');
      }
    });

    Array.prototype.forEach.call(
      gallery.querySelectorAll('[data-product-thumb]'),
      function (button, i) {
        button.setAttribute('aria-pressed', i === target ? 'true' : 'false');
      }
    );

    syncLightbox(gallery);
  }

  /* Full-screen viewer ------------------------------------------------------ */

  var lightboxes = {};
  var openGallery = null;

  function lightboxFor(gallery) {
    var section = gallery.closest('[data-section-id], .shopify-section') || document;
    return section.querySelector('[data-media-lightbox]')
      || document.querySelector('[data-media-lightbox]');
  }

  function syncLightbox(gallery) {
    var box = lightboxFor(gallery);
    /* Only worth repainting while it is on screen; opening repopulates it. */
    if (!box || !box.classList.contains('is-open')) return;
    paintLightbox(gallery, box);
  }

  function paintLightbox(gallery, box) {
    var frames = galleryFrames(gallery);
    var index = activeIndex(gallery);
    var frame = frames[index];
    if (!frame) return;

    var image = box.querySelector('[data-lightbox-img]');
    var thumbImg = frame.querySelector('img');

    if (image) {
      /* The 2400px source, requested only now that someone has asked to see the
         photo properly. */
      var full = frame.getAttribute('data-full-src');
      if (full) image.setAttribute('src', full);
      else if (thumbImg) image.setAttribute('src', thumbImg.currentSrc || thumbImg.src);
      image.setAttribute('alt', thumbImg ? thumbImg.getAttribute('alt') || '' : '');

      /* Carry this frame's real ratio across. The photos are not all the same
         shape — the studio fronts are square, the back labels are not — so
         leaving the seeded attributes in place letterboxes inside the figure
         until the new source finishes decoding. */
      if (thumbImg && thumbImg.naturalWidth && thumbImg.naturalHeight) {
        image.setAttribute('width', thumbImg.naturalWidth);
        image.setAttribute('height', thumbImg.naturalHeight);
      }
    }

    var counter = box.querySelector('[data-lightbox-count]');
    if (counter) {
      var template = counter.getAttribute('data-label-position') || '';
      counter.textContent = template
        .replace('{index}', index + 1)
        .replace('{total}', frames.length);
    }
  }

  function getLightbox(gallery) {
    var element = lightboxFor(gallery);
    if (!element) return null;
    if (!element.id) element.id = 'ProductLightbox-fallback';
    if (!lightboxes[element.id]) {
      lightboxes[element.id] = window.GG && window.GG.dialog
        ? window.GG.dialog(element, {
            initialFocus: '[data-dialog-close]',
            /* Drop the reference on close, or the viewer's arrows keep driving
               a gallery nobody is looking at. */
            onClose: function () { openGallery = null; }
          })
        : null;
    }
    return lightboxes[element.id];
  }

  function openLightbox(gallery, trigger) {
    var element = lightboxFor(gallery);
    var instance = getLightbox(gallery);
    if (!element || !instance) return;
    openGallery = gallery;
    paintLightbox(gallery, element);
    instance.open(trigger);
  }

  /* Clicks ------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      var thumbGallery = thumb.closest('[data-product-gallery]');
      if (thumbGallery) {
        showFrame(thumbGallery, parseInt(thumb.getAttribute('data-media-index'), 10) || 0);
      }
      return;
    }

    var step = event.target.closest('[data-media-prev], [data-media-next]');
    if (step) {
      /* The same two controls exist on the stage and inside the viewer. Inside
         it there is no [data-product-gallery] ancestor, so fall back to whichever
         gallery opened it. */
      var stepGallery = step.closest('[data-product-gallery]') || openGallery;
      if (stepGallery) {
        var delta = step.hasAttribute('data-media-next') ? 1 : -1;
        showFrame(stepGallery, activeIndex(stepGallery) + delta);
      }
      return;
    }

    var expand = event.target.closest('[data-media-expand]');
    if (expand) {
      var expandGallery = expand.closest('[data-product-gallery]');
      if (expandGallery) openLightbox(expandGallery, expand);
      return;
    }

    /* Clicking the photo itself opens the viewer too. The expand button is what
       makes this reachable by keyboard and what announces it; this is the
       convenience path for a mouse. */
    var frame = event.target.closest('[data-media-frame]');
    if (frame && !frame.closest('[data-media-lightbox]')) {
      var frameGallery = frame.closest('[data-product-gallery]');
      if (frameGallery) openLightbox(frameGallery, frame);
    }
  });

  /* Keyboard ---------------------------------------------------------------- */

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    var delta = event.key === 'ArrowRight' ? 1 : -1;

    /* While the viewer is open the arrows drive it wherever focus sits — it is
       modal, so nothing else on the page can reasonably want them. */
    var element = openGallery ? lightboxFor(openGallery) : null;
    if (element && element.classList.contains('is-open')) {
      event.preventDefault();
      showFrame(openGallery, activeIndex(openGallery) + delta);
      return;
    }

    /* Otherwise only when focus is inside the gallery, so arrow keys keep
       working normally everywhere else on the page. */
    var focused = document.activeElement;
    if (!focused) return;
    var gallery = focused.closest ? focused.closest('[data-product-gallery]') : null;
    if (!gallery) return;
    event.preventDefault();
    showFrame(gallery, activeIndex(gallery) + delta);
  });

  /* Pack builder ----------------------------------------------------------- */

  function packRows(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-pack-qty]'));
  }

  function packTotal(form) {
    return packRows(form).reduce(function (sum, input) {
      var value = parseInt(input.value, 10);
      return sum + (isNaN(value) || value < 0 ? 0 : value);
    }, 0);
  }

  function packUpdate(form) {
    var size = parseInt(form.getAttribute('data-pack-size'), 10) || 6;
    var total = packTotal(form);
    var remaining = size - total;
    var status = form.querySelector('[data-pack-count]');
    var submit = form.querySelector('[data-pack-submit]');
    var state = total === size ? 'full' : total > size ? 'over' : total === 0 ? 'empty' : 'partial';

    form.setAttribute('data-pack-state', state);

    /* Outline the rows that have something in them. Not colour alone — the
       label goes semibold too, see the stylesheet. */
    packRows(form).forEach(function (input) {
      var row = input.closest('.pack__row');
      if (row) {
        row.setAttribute('data-pack-chosen', (parseInt(input.value, 10) > 0).toString());
      }
    });

    if (status) {
      if (state === 'full') {
        status.textContent = form.getAttribute('data-label-complete') || '';
      } else if (state === 'over') {
        status.textContent = (form.getAttribute('data-label-over') || '').replace('{count}', total - size);
      } else {
        /* {total} as well as {count} — the size is whatever variant is selected
           right now, so it cannot have been baked in at render time. */
        status.textContent = (form.getAttribute('data-label-progress') || '')
          .replace('{count}', total)
          .replace('{total}', size);
      }
    }

    if (submit) {
      /* Only an exact pack can be added. The button is disabled here rather
         than in Liquid so that with JavaScript off it stays clickable and the
         native POST still works — a pack filled wrongly is recoverable, a pack
         that can never be bought is not. */
      submit.disabled = state !== 'full';

      if (state === 'full') {
        submit.textContent = submit.getAttribute('data-label-ready') || '';
      } else if (state === 'over') {
        submit.textContent = (form.getAttribute('data-label-over') || '').replace('{count}', total - size);
      } else if (remaining === 1) {
        submit.textContent = form.getAttribute('data-label-submit-one') || '';
      } else {
        submit.textContent = (form.getAttribute('data-label-submit-other') || '').replace('{count}', remaining);
      }
    }
  }

  /* Steppers, delegated so a theme-editor reload needs no re-binding. */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-pack-step]');
    if (!step) return;

    var form = step.closest('[data-pack-form]');
    if (!form) return;

    var input = step.parentElement.querySelector('[data-pack-qty]');
    if (!input) return;

    var size = parseInt(form.getAttribute('data-pack-size'), 10) || 6;
    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < 0) current = 0;

    var next = current + parseInt(step.getAttribute('data-pack-step'), 10);
    if (next < 0) next = 0;
    if (next > size) next = size;

    input.value = next;
    packUpdate(form);
  });

  /* A plain multi-variant product — a variety sold in 2/4/6 — has a
     <select name="id"> from the buy_buttons block and NO pack builder. The pack
     handler below cannot serve it: it returns early when there is no
     [data-pack-form], so before this the price row, the heading and the button
     label all stayed on the previously selected variant while the form posted
     the new one. Checkout charged correctly and the page lied about it.

     Deliberately a SEPARATE handler rather than a generalisation of the pack
     one: [data-variant-select] is on the buy_buttons select only, so the two
     never both fire and the working pack builder is untouched.

     The price rows are server-rendered by Liquid, one per variant; this toggles
     which is visible rather than rewriting a number, so price, savings figure
     and free-shipping badge can never disagree with checkout. */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-variant-select]');
    if (!select) return;

    var chosen = select.options[select.selectedIndex];
    if (!chosen) return;

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-price-variant]'),
      function (row) {
        row.hidden = row.getAttribute('data-price-variant') !== select.value;
      }
    );

    /* Only when the merchant asked for the size in the heading. Without the
       attribute check this would append a variant name to a heading that was
       deliberately configured not to have one. */
    var titleEl = document.querySelector('[data-product-title][data-title-append]');
    if (titleEl) {
      var base = titleEl.getAttribute('data-title-base');
      var suffix = chosen.getAttribute('data-variant-title');
      if (base && suffix) titleEl.textContent = base + ' ' + suffix;
    }

    var form = select.form;
    var addBtn = form && form.querySelector('[data-variant-add]');
    var addLabel = chosen.getAttribute('data-add-label');
    if (addBtn && addLabel) addBtn.textContent = addLabel;
  });

  /* Changing pack size is a variant change, so the whole builder has to re-key:
     the form's target count, every row's max, and the labels. Delegated for the
     same reason as the steppers — a theme-editor reload rebinds nothing. */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-pack-variant]');
    if (!select) return;

    var form = select.closest('[data-pack-form]');
    if (!form) return;

    var chosen = select.options[select.selectedIndex];
    var size = parseInt(chosen && chosen.getAttribute('data-pack-size'), 10);
    if (!(size > 0)) return;

    var total = packTotal(form);
    form.setAttribute('data-pack-size', size);

    /* Swap the gallery to this size's photo. Rather than duplicate the frame and
       thumbnail bookkeeping, click the matching thumbnail and let the delegated
       handler above do it — one code path, already proven. */
    var mediaIndex = chosen.getAttribute('data-media-index');
    if (mediaIndex !== null) {
      var thumb = document.querySelector('[data-product-thumb][data-media-index="' + mediaIndex + '"]');
      if (thumb) {
        thumb.click();
      } else {
        /* Thumbnails are hidden on the pack template, so there is nothing to
           click — activate the frame directly. Same attributes the delegated
           thumbnail handler sets, so the fly-to-cart source keeps pointing at
           whatever is actually on screen. */
        Array.prototype.forEach.call(
          document.querySelectorAll('[data-media-frame]'),
          function (frame) {
            var active = frame.getAttribute('data-media-frame') === mediaIndex;
            frame.classList.toggle('is-active', active);
            if (active) {
              frame.setAttribute('data-fly-hero', '');
            } else {
              frame.removeAttribute('data-fly-hero');
            }
          }
        );
      }
    }

    /* The heading names the size, so it has to follow the picker. */
    var titleEl = document.querySelector('[data-product-title]');
    if (titleEl) {
      var base = titleEl.getAttribute('data-title-base');
      if (base) titleEl.textContent = base + ' ' + chosen.textContent.split('·')[0].trim();
    }

    /* The price row has to follow it too. Every variant's row is rendered by
       Liquid; show the one whose id matches and hide the rest. Toggling
       server-rendered markup rather than rewriting the number means the price,
       the savings figure and the free-shipping badge can never disagree with
       checkout. Before this, switching size changed the title and left the
       price on the previous variant. */
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-price-variant]'),
      function (row) {
        row.hidden = row.getAttribute('data-price-variant') !== select.value;
      }
    );

    packRows(form).forEach(function (input) {
      input.setAttribute('max', size);
    });

    /* Only clear the picks that can no longer fit. Going 2-Pack -> 6-Pack keeps
       what the shopper already chose; going 6-Pack -> 2-Pack would otherwise
       drop them into the 'over' state through no action of their own. Clearing
       the whole set on every switch would throw away valid choices. */
    if (total > size) {
      packRows(form).forEach(function (input) {
        input.value = 0;
      });
    }

    packUpdate(form);
  });

  /* Typing straight into the number input has to count too. */
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-pack-qty]');
    if (!input) return;

    var form = input.closest('[data-pack-form]');
    if (form) packUpdate(form);
  });

  /* Zero rows would otherwise reach the order as "Crimini: 0". A disabled
     input is not submitted, so they are switched off at the last moment and
     switched straight back on in case the POST is interrupted. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-pack-form]');
    if (!form) return;

    var emptied = packRows(form).filter(function (input) {
      return !(parseInt(input.value, 10) > 0);
    });

    emptied.forEach(function (input) { input.disabled = true; });
    window.setTimeout(function () {
      emptied.forEach(function (input) { input.disabled = false; });
    }, 0);
  });

  /* First run: disables the button until the pack is exact. */
  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pack-form]'), packUpdate);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipe"] && !Shopify.designMode) return;
  try {
    
  /* main-recipe — the recipe video plays only when its button is pressed. */
  (function () {
    function setup(box) {
      if (box.getAttribute('data-gg-ready') === 'true') return;
      var video = box.querySelector('video');
      var play = box.querySelector('[data-gg-recipe-video-play]');
      if (!video || !play) return;
      box.setAttribute('data-gg-ready', 'true');
      video.controls = false;

      play.addEventListener('click', function () {
        box.classList.add('is-playing');
        video.controls = true;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
        video.focus();
      });
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gg-recipe-video]'), setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recipes"] && !Shopify.designMode) return;
  try {
    
  /* product-recipes — a reel plays only when its button is pressed (draft). */
  (function () {
    function setup(card) {
      if (card.getAttribute('data-gg-video-ready') === 'true') return;
      var video = card.querySelector('video');
      var play = card.querySelector('[data-gg-video-play]');
      if (!video || !play) return;
      card.setAttribute('data-gg-video-ready', 'true');

      play.addEventListener('click', function () {
        card.classList.add('is-playing');
        video.controls = true;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
        video.focus();
      });

      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
        video.controls = false;
      });
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-gg-uses] [data-gg-video]'), setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
